// @flow

import { connect } from 'react-redux';
import { get } from 'lodash';
import * as React from 'react';

import type { StoreState } from '../../../../redux/types';

const DESIGN_TOP = 267;
const DESIGN_WIDTH = 100;
const DESIGN_HEIGHT = 160;

type OwnProps = {|
  scale: number,
|};
type Props = {
  ...OwnProps,
  avatar: ?string,
};

const Uriko = (props: Props) => {
  const style = {
    position: 'absolute',
    top: `${DESIGN_TOP * props.scale}px`,
    width: `${DESIGN_WIDTH * props.scale}px`,
    height: `${DESIGN_HEIGHT * props.scale}px`,
    right: 549 * props.scale,
    margin: '0 auto',
  };
  return <div className={`uriko uriko-${props.avatar || 1}`} style={style} />;
};

const mapStateToProps = (state: StoreState) => ({
  avatar: get(state, 'profile.avatar'),
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(Uriko);
